export default [
  {
    path: '/counting',
    name: 'Counting',
    component: () => import('@/layout'),
    redirect: '/counting/main',
    meta: {
      title: '对账中心',
    },
    children: [
      {
        path: 'main',
        name: 'tradeMainList',
        component: () => import('@/views/web/counting/main'),
        meta: {
          title: '对账主体管理',
          noCache: false,
          auth: true,
          trackCode: 'menu-23',
          trackName: '对账中心 - 对账主体管理',
          activeMenu: '/counting/main',
        },
      },
      {
        path: 'trade/receipt',
        name: 'tradeListReceipt',
        component: () => import('@/views/web/counting/trade/receipt'),
        meta: {
          title: '对账-收款交易',
          noCache: false,
          auth: true,
          trackCode: 'menu-8',
          trackName: '对账中心 - 对账-收款交易',
          activeMenu: '/counting/trade/receipt',
        },
      },
      {
        path: 'trade/payment',
        name: 'tradeListPayment',
        component: () => import('@/views/web/counting/trade/payment'),
        meta: {
          title: '对账-代付',
          noCache: false,
          auth: true,
          trackCode: 'menu-9',
          trackName: '对账中心 - 对账-代付',
          activeMenu: '/counting/trade/payment',
        },
      },
      {
        path: 'diff/receipt',
        name: 'diffListReceipt',
        component: () => import('@/views/web/counting/diff/receipt'),
        meta: {
          title: '异常处理-收款',
          noCache: false,
          auth: true,
          trackCode: 'menu-10',
          trackName: '对账中心 - 异常处理-收款',
          activeMenu: '/counting/diff/receipt',
        },
      },
      {
        path: 'diff/payment',
        name: 'diffListPayment',
        component: () => import('@/views/web/counting/diff/payment'),
        meta: {
          title: '异常处理-代付',
          noCache: false,
          auth: true,
          trackCode: 'menu-11',
          trackName: '对账中心 - 异常处理-代付',
          activeMenu: '/counting/diff/payment',
        },
      },
      {
        path: 'bill',
        name: 'CountingBill',
        component: () => import('@/views/web/counting/bill'),
        meta: {
          title: '账单管理',
          noCache: false,
          auth: true,
          trackCode: 'menu-12',
          trackName: '对账中心 - 账单管理',
          activeMenu: '/counting/bill',
        },
      },
      {
        path: 'channel-report',
        name: 'channelReportList',
        component: () => import('@/views/web/counting/channel-report'),
        meta: {
          title: '渠道手续费日报表',
          noCache: false,
          auth: true,
          trackCode: 'menu-counting-1',
          trackName: '对账中心 - 账单管理',
          activeMenu: '/counting/channel-report',
        },
      },
    ],
  },
];
